<template>
  <div class="h-full rounded-lg flex flex-col gap-2">
    <div
      class="max-h-full flex flex-col gap-2 overflow-y-auto scrollbar-thin scrollbar-tema"
    >
      <AppFilterForm
        :tabela="tabela"
        :visibility="show_form_filter"
        @close="closeFilterForm"
      />
      <div class="flex flex-col gap-2 lg:flex-row">
        <AppFamiliaForm
          :podeGerir="podeGerir"
          :show="showFamiliaForm"
          @close="closeForm"
          :form_title="formTitle"
          :form_data="familiaFormData"
          :create_btn="create_btn"
          @show_table="showFamily"
          :showRight="showRight"
          @create="createFamilia"
          @update="updateFamilia"
          @delete="disableEnable"
        />

        <AppProdutoForm
          :podeGerir="podeGerir"
          :show="showProdutoForm"
          :create_btn="create_btn"
          @close="closeForm"
          @show_form="openSubForm"
          :form_data="produtoFormData"
          :form_title="formTitle"
          @selectTable="showProduto"
          :showRight="showRight"
          @create="createProduto"
          :set_data="familiaSelected"
          @update="updateProduto"
          @disable="disableEnable"
        />

        <AppTipologiaForm
          :podeGerir="podeGerir"
          :show="showTipologiaForm"
          @close="closeForm"
          :create_btn="create_btn"
          @show_table="showTipologia"
          :showRight="showRight"
          :set_data="set_data"
          @create="createTipologia"
          :form_data="tipologiaFormData"
          :form_title="tipologiaFormTitle"
          @disable="disableEnable"
          @update="updateTiplogia"
        />

        <div class="flex flex-col gap-2 w-full">
          <div
            v-if="showProps"
            class="bg-[var(--fundoForm)] flex flex-col gap-2 p-2 rounded-md"
          >
            <div class="w-full text-right px-2 text-[var(--text)]">
              <i
                class="fa-regular fa-circle-xmark fa-xl cursor-pointer"
                @click="closeProps"
              ></i>
            </div>
            <h3 style="color: var(--titulo)">Propriedades:</h3>
            <div class="flex gap-1">
              <label for="codigo" class="text-[var(--text)] w-16">Nome:</label>
              <input
                type="text"
                v-model="familyPropsData.nome"
                placeholder="Nome"
                class="rounded-md px-1 text-xs"
              />
            </div>
            <div class="flex gap-1">
              <label for="codigo" class="text-[var(--text)] w-16">Tipo:</label>
              <select
                v-model="familyPropsData.tipo"
                id="tipo"
                class="rounded-md px-1 text-xs w-[145px]"
              >
                <option value="int">int</option>
                <option value="double">double</option>
                <option value="data">data</option>
              </select>
            </div>
            <div class="flex gap-2">
              <button
                v-if="(podeGerir && !familyPropsData.id) && validPermission('P0012')"
                class="btn"
                @click="createFamilyProps(familyPropsData)"
              >
                Criar
              </button>

              <!-- Atualizar and Delete buttons are shown if familyPropsData.id exists -->
              <button
                v-if="(podeGerir && familyPropsData.id) && validPermission('P0012')"
                class="btn"
                @click="updateFamilyProps(familyPropsData)"
              >
                Atualizar
              </button>
              <button
                v-if="(podeGerir && familyPropsData.id) && validPermission('P0012')"
                class="btn"
                @click="deleteFamilyProps(familyPropsData)"
              >
                {{
                  familyPropsData.status === "ativo" ? "Desativar" : "Ativar"
                }}
              </button>
            </div>
          </div>
          <div
            v-if="showProdutoProps"
            class="bg-[var(--fundoForm)] p-4 rounded-lg shadow-md flex flex-col gap-4"
          >
            <!-- Fechar -->
            <div class="flex justify-end">
              <button @click="closeProps" class="text-[var(--text)] hover:text-red-400">
                <i class="fa-regular fa-circle-xmark fa-xl"></i>
              </button>
            </div>

            <h3 class="font-semibold text-[#ff9b05]">Propriedades</h3>

            <!-- Grid de inputs -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="flex flex-col">
                <label for="nome" class="text-[var(--text)] mb-1">Nome</label>
                <input
                  id="nome"
                  v-model="produtoPropsData.nome"
                  type="text"
                  placeholder="Digite o nome"
                  class="rounded-md border px-3 py-1 text-sm text-black"
                  :class="{ 'input-required': !produtoPropsData.nome }"
                />
              </div>

              <div class="flex flex-col">
                <label for="tipo" class="text-[var(--text)] mb-1">Tipo</label>
                <select
                  id="tipo"
                  v-model="produtoPropsData.tipo"
                  class="rounded-md border px-3 py-1 text-sm bg-white text-black"
                  :class="{ 'input-required': !produtoPropsData.tipo }"
                >
                  <option value="number">number</option>
                  <option value="text">text</option>
                  <option value="double">double</option>
                  <option value="data">data</option>
                  <option value="select">select</option>
                </select>
              </div>
            </div>

            <!-- Opções para select -->
            <transition-group
              name="fade"
              tag="div"
              v-if="produtoPropsData.tipo === 'select'"
              class="space-y-3"
            >
              <div key="opts-header" class="flex items-center justify-between">
                <h4 class="text-[var(--text)] font-medium">Opções</h4>
                <button
                  v-if="podeGerir"
                  @click="addOpcao"
                  class="flex items-center gap-1 text-xs font-semibold px-3 py-1 rounded bg-green-600 hover:bg-green-500 transition"
                >
                  <i class="fa-solid fa-plus"></i>
                  Adicionar
                </button>
              </div>

              <div
                v-for="(opc, idx) in produtoPropsData.opcoes"
                :key="idx"
                class="flex items-center gap-3"
              >
                <input
                  v-model="opc.valor_label"
                  type="text"
                  placeholder="Rótulo da opção"
                  class="flex-1 rounded-md border px-3 py-1 text-sm text-black"
                />
                <button
                  v-if="podeGerir"
                  @click="removeOpcao(idx)"
                  class="text-white p-2 rounded-md bg-red-600 hover:bg-red-500 transition"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </transition-group>

            <!-- Ações -->
            <div class="flex justify-end gap-3">
              <button
                v-if="(podeGerir && !produtoPropsData.id) && validPermission('P0027')"
                @click="createProdutoProps(produtoPropsData)"
                :disabled="!produtoPropsData.nome || !produtoPropsData.tipo"
                class="px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-500 text-white text-sm transition disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Criar
              </button>
              <button
                v-if="(podeGerir && produtoPropsData.id) && validPermission('P0027')"
                @click="updateProdutoProps(produtoPropsData)"
                class="px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-500 text-white text-sm transition"
              >
                Atualizar
              </button>
              <button
                v-if="(podeGerir && produtoPropsData.id) && validPermission('P0027')"
                @click="deleteProdutoProps(produtoPropsData)"
                class="px-4 py-2 rounded-md bg-red-600 hover:bg-red-500 text-white text-sm transition"
              >
                Apagar
              </button>
            </div>
          </div>

          <div
            v-if="showSparesForm"
            class="flex flex-col w-full bg-[var(--fundoForm)] p-2 rounded-md"
          >
            <div class="w-full text-right px-2 text-[var(--text)]">
              <i
                class="fa-regular fa-circle-xmark fa-xl cursor-pointer"
                @click="closeProps"
              ></i>
            </div>
            <h3 style="color: #ff9b05">Spares:</h3>
            <div class="flex w-full gap-2">
              <div class="flex flex-col gap-1 w-32 h-full">
                <label for="codigo" class="text-[var(--text)]"
                  >Potenciação Absoluta:</label
                >
                <input
                  type="number"
                  v-model="newSpareForm.potenciacaoAbsoluta"
                  placeholder="1"
                  class="rounded-md p-1 text-xs"
                  :class="{ 'input-required': !newSpareForm.potenciacaoAbsoluta && !newSpareForm.potenciacaoRelativa }"
                  @input="verifyFormSpares"
                />
              </div>
              <div class="flex flex-col gap-1 w-32 h-full">
                <label for="codigo" class="text-[var(--text)]"
                  >Potenciação Relativa:</label
                >
                <input
                  type="number"
                  v-model="newSpareForm.potenciacaoRelativa"
                  placeholder="0%"
                  class="rounded-md p-1 text-xs"
                  :class="{ 'input-required': !newSpareForm.potenciacaoAbsoluta && !newSpareForm.potenciacaoRelativa }"
                  @input="verifyFormSpares"
                />
              </div>
              <div class="flex flex-col gap-1 w-32 h-full justify-center">
                <label for="codigo" class="text-[var(--text)] h-[45px]">Produto:</label>
                <select
                  v-if="!updateSpare"
                  v-model="newSpareForm.produto"
                  id="small"
                  class="block w-ful p-1 text-sm text-white rounded-lg bg-[#626288] focus:ring-[#a53535] focus:border-[#b44d4d] outline-none"
                  :class="{ 'input-required': !newSpareForm.produto }"
                  @change="verifyFormSpares"
                >
                  <option
                    v-for="(tipo, index) in this.filteredSparesByFamilia"
                    :key="index"
                    :value="tipo"
                    :selected="index === 0"
                  >
                    {{ tipo.produto }}
                  </option>
                </select>
                <input
                  v-if="updateSpare"
                  type="text"
                  text-[var(--text)]
                  v-model="newSpareForm.nome"
                  class="rounded-md p-1 text-xs"
                  disabled
                />
              </div>
              <div class="flex items-end h-full">
                <div class="flex gap-1">
                  <button
                    v-if="(podeGerir && veBtnCreate) && validPermission('P0027')"
                    class="text-white text-xs p-2 rounded-lg bg-blue-600 hover:none"
                    @click="createSpare"
                  >
                    Criar
                  </button>
                  <button
                    v-if="(podeGerir && updateSpare) && validPermission('P0027')"
                    class="text-white text-xs p-2 rounded-lg bg-blue-600 hover:none"
                    @click="updateSpares"
                  >
                    Atualizar
                  </button>
                  <button
                    v-if="(podeGerir && updateSpare) && validPermission('P0027')"
                    class="text-white text-xs p-2 rounded-lg bg-red-600 hover:none"
                    @click="deleteSpares"
                  >
                    Apagar
                  </button>
                  <button
                    v-if="podeGerir && updateSpare"
                    class="text-white text-xs p-2 rounded-lg bg-orange-600 hover:none"
                    @click="atualizaSel"
                  >
                    Deseleciona
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="flex flex-col gap-2">
            <div class="flex gap-2">
              <div
                v-if="showServicoData"
                class="bg-[#43436d] rounded-md p-2 pt-4 flex flex-col gap-2 w-full"
              >
                <div class="flex items-center justify-between w-full gap-x-4">
                  <!-- Propriedades do Serviço -->
                  <p class="text-[#ff9b05]">Propriedades do Serviço:</p>

                  <!-- Tempo Médio com o Input -->
                  <div class="flex items-center gap-2">
                    <div class="text-[var(--text)] text-sm">Tempo Médio:</div>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      placeholder="0"
                      class="w-32 rounded-md px-1 text-sm"
                      ref="tempoMedioInput"
                      v-model="servicoToUpdate.tempo_medio"
                    />
                  </div>

                  <!-- Botões juntos -->
                  <div v-if="podeGerir" class="flex gap-2">
                    <button v-if="validPermission('P0027')"
                      class="text-white text-xs p-2 rounded-lg bg-blue-600 hover:none"
                      @click="updateTempoMedio"
                    >
                      Atualizar
                    </button>

                    <button v-if="validPermission('P0027')"
                      class="text-white text-xs p-2 rounded-lg bg-red-600 hover:none"
                      @click="apagaServicoProduto"
                    >
                      Apagar tipo Serviço
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="showServicoTable"
              class="flex flex-col gap-2"
            >
              <AppTable
                :visibility="showGenericTable"
                :show="showServicoTable"
                hiddenHeaders="['id']"
                :table_data="ServicoProduto"
                table_title="Serviços do Produto"
                @close="close_generic_table"
                @row-clicked="SelectServicoProduto"
              />
            </div>

            <div v-if="showCamposSeparadoresForm && !showRight">
              <CampoSeparadorForm
                :initialData="initialData"
                :mode="mode"
                @cancel="showCamposSeparadoresForm = false"
                @saved="getCampoSeparadores(initialData.tpSeparador_id)"
                @deleted="getCampoSeparadores(initialData.tpSeparador_id)"
              />
            </div>
            <div
              v-if="showCamposSeparadoresTable && !showRight"
              class="rounded-md flex flex-col gap-2"
            >
              <AppTable
                :visibility="showGenericTable"
                :show="showCamposSeparadoresTable"
                hiddenHeaders="['id','tpSeparador_id']"
                :table_data="CamposSeparadores"
                table_title="Campos do Separador"
                @close="close_generic_table"
                @row-clicked="SelectCampoSeparador"
              />
            </div>

            <AppTable
              :visibility="showGenericTable"
              :show="showGenericTable"
              hiddenHeaders="['familia_id','id','produto_id','produt_spares_id','opcoes']"
              :table_data="generic_table_data"
              :table_title="generic_table_title"
              @row-clicked="select_generic_row"
              @close="close_generic_table"
            />
          </div>
        </div>
      </div>
      <div class="w-full flex flex-col gap-2">
         <FamiliaFilter v-if="showFamiliaFilter" @filtersChanged="updateFilters" @close-filter="showFamiliaFilter = false"/>
         <ProdutoFilter v-if="showProdutoFilter" @filtersChanged="updateFilters" @close-filter="showProdutoFilter = false"/>
         <TipologiaFilter v-if="showTipologiaFilter" @filtersChanged="updateFilters" @close-filter="showTipologiaFilter = false"/>
        <GenericDataTable
          v-if="validPermission('P0006') && show_table"
          ref="dataTableRef"
          @row-click="select"
          :api-url="`${baseURl}/api/v1/familia/pagination/`"
          :useServerSide="true"
          :columns="familiaColumns"
          :preserve-api-order="true"
          :initial-params="currentFilters"
          :show_export="true"
          :show_close_btn="false"
          table_title="Familias"
        >
          <template #left-actions>
            <button
              class="action-btn filter-btn"
              @click="showFamiliaFilter  = !showFamiliaFilter"
              title="Filtros"
            >
              <i class="fa-solid fa-filter"></i>
            </button>
            <button
              v-if="(podeGerir) && validPermission('P0003')"
              class="action-btn filter-btn"
              @click="triggerAction({ action: 'create_familia' })"
              title="Adicionar"
            >
              <i class="fa-solid fa-circle-plus fa-xl"></i>
            </button>
            <button
              class="action-btn filter-btn"
              @click="triggerAction({ action: 'show_produto' })"
              title="Produto"
            >
              <i class="fa-solid fa-box fa-xl"></i>
            </button>
            <button
              class="action-btn filter-btn"
              @click="triggerAction({ action: 'show_tipologia' })"
              title="Tipologia"
            >
              <i class="fa-solid fa-tags fa-xl"></i>
            </button>
          </template>
        </GenericDataTable>
        <GenericDataTable
          v-if="validPermission('P0006') && showProdutoTable"
          ref="dataTableRef"
          @row-click="selectP"
          :api-url="`${baseURl}/api/v1/produto/pagination/`"
          :useServerSide="true"
          :columns="produtoColumns"
          :preserve-api-order="true"
          :initial-params="currentFilters"
          :show_export="true"
          :show_close_btn="false"
          table_title="Produtos"
        >
          <template #left-actions>
            <button
              class="action-btn filter-btn"
              @click="showProdutoFilter = !showProdutoFilter"
              title="Filtros"
            >
              <i class="fa-solid fa-filter"></i>
            </button>
            <button
              v-if="(podeGerir) && validPermission('P0003')"
              class="action-btn filter-btn"
              @click="triggerAction({ action: 'create_produto' })"
              title="Adicionar"
            >
              <i class="fa-solid fa-circle-plus fa-xl"></i>
            </button>
            <button
              class="action-btn filter-btn"
              @click="triggerAction({ action: 'show_familia' })"
              title="Familia"
            >
              <i class="fa-solid fa-sitemap fa-xl"></i>
            </button>
            <button
              class="action-btn filter-btn"
              @click="triggerAction({ action: 'show_tipologia' })"
              title="Tipologia"
            >
              <i class="fa-solid fa-tags fa-xl"></i>
            </button>
          </template>
        </GenericDataTable>
        <GenericDataTable
          v-if="validPermission('P0006') && showTipologiaTable"
          ref="dataTableRef"
          @row-click="selectTipologia"
          :api-url="`${baseURl}/api/v1/tipologia/pagination/`"
          :useServerSide="true"
          :columns="tipologiaColumns"
          :preserve-api-order="true"
          :initial-params="currentFilters"
          :show_export="true"
          :show_close_btn="false"
          table_title="Tipologias"
        >
          <template #left-actions>
            <button
              class="action-btn filter-btn"
              @click="showTipologiaFilter = !showTipologiaFilter"
              title="Filtros"
            >
              <i class="fa-solid fa-filter"></i>
            </button>
            <button
              v-if="(podeGerir) && validPermission('P0003')"
              class="action-btn filter-btn"
              @click="triggerAction({ action: 'create_tipologia' })"
              title="Adicionar"
            >
              <i class="fa-solid fa-circle-plus fa-xl"></i>
            </button>
            <button
              class="action-btn filter-btn"
              @click="triggerAction({ action: 'show_familia' })"
              title="Familia"
            >
              <i class="fa-solid fa-sitemap fa-xl"></i>
            </button>
              <button
              class="action-btn filter-btn"
              @click="triggerAction({ action: 'show_produto' })"
              title="Produto"
            >
              <i class="fa-solid fa-box fa-xl"></i>
            </button>
          </template>
        </GenericDataTable>
        <!-- <AppPaginationTable
          :visibility="this.validPermission('P0006')"
          :show="show_table"
          :filterBtn="true"
          :refresh="refresh_table"
          :table_title="table_title"
          :data="filter_familia_data"
          :url-string="familia_url"
          :AddRemoveBtn="{
            verProduto: true,
            verTipologia: true,
            verAdicionar: this.validPermission('P0003'),
          }"
          @open-produto="triggerAction({ action: 'show_produto' })"
          @open-tipologia="triggerAction({ action: 'show_tipologia' })"
          @open-adicionar="triggerAction({ action: 'create_familia' })"
          @open-filter="showFamiliaFilter = true"
          @row-clicked="select"
          @delete_data="remove_familia"
          @refreshed="checkAndResetRefreshTable"
        /> -->
        <!-- <AppPaginationTable
          :visibility="this.validPermission('P0006')"
          :show="showProdutoTable"
          :filterBtn="true"
          :refresh="refresh_table"
          :table_title="table_title"
          :data="filter_produto_data"
          :url-string="produto_url"
          :AddRemoveBtn="{
            verFamilia: true,
            verTipologia: true,
            verAdicionar: this.validPermission('P0003'),
          }"
          @open-adicionar="triggerAction({ action: 'create_produto' })"
          @open-familia="triggerAction({ action: 'show_familia' })"
          @open-tipologia="triggerAction({ action: 'show_tipologia' })"
          @open-filter="showProdutoFilter = true"
          @row-clicked="selectP"
          @delete_data="null"
          @refreshed="checkAndResetRefreshTable"
        /> -->
        <!-- <AppPaginationTable
          :visibility="this.validPermission('P0006')"
          :show="showTipologiaTable"
          :filterBtn="true"
          :refresh="refresh_table"
          :table_title="table_title"
          :data="filter_tipologia_data"
          :url-string="tipologia_url"
          :AddRemoveBtn="{
            verFamilia: true,
            verProduto: true,
            verAdicionar: this.validPermission('P0003'),
          }"
          @open-adicionar="triggerAction({ action: 'create_tipologia' })"
          @open-familia="triggerAction({ action: 'show_familia' })"
          @open-produto="triggerAction({ action: 'show_produto' })"
          @open-filter="showTipologiaFilter = true"
          @row-clicked="selectTipologia"
          @delete_data="null"
          @refreshed="checkAndResetRefreshTable"
        /> -->
      </div>
      <!-- <FamiliaFilter
        v-if="showFamiliaFilter"
        :data="filter_familia_data"
        @save="set_filter"
        @close="showFamiliaFilter = false"
      /> -->
      <!-- <ProdutoFilter
        v-if="showProdutoFilter"
        :data="filter_produto_data"
        @save="set_filter"
        @close="showProdutoFilter = false"
      /> -->
      <!-- <TipologiaFilter
        v-if="showTipologiaFilter"
        :data="filter_tipologia_data"
        @save="set_filter"
        @close="showTipologiaFilter = false"
      /> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AppTable from "@/components/tables/table.vue";
import AppProfileSearch from "@/components/profileSearch.vue";
import AppNotification from "@/components/notification.vue";
import AppSearch from "@/components/search.vue";
import AppForm from "@/components/form.vue";
import AppFilter from "@/components/filter/filter.vue";
import AppActionCard from "@/components/actionCard.vue";
import "@fortawesome/fontawesome-free/css/all.css";
import permissionMixin from "@/permissionMixin.js";
import { podeGerirFamiliasEquipamentos } from "@/utils/valencias";
import AppProdutoForm from "@/components/forms/familiaProdutoTipologia/produtoForm.vue";
import AppFamiliaForm from "@/components/forms/familiaProdutoTipologia/familiaForm.vue";
import AppTipologiaForm from "@/components/forms/familiaProdutoTipologia/tipologiaForm.vue";
import AppFilterForm from "@/components/filter/filterForm.vue";
import AppPaginationTable from "@/components/tablePagination/tablePagination.vue";
// import FamiliaFilter from "@/components/popUps/familiaFilter.vue";
// import ProdutoFilter from "@/components/popUps/produtoFilter.vue";
// import TipologiaFilter from "@/components/popUps/tipologiaFilter.vue";
import { toast } from "vue3-toastify";
import { id as loggedID } from "@/extraData";
import CampoSeparadorForm from "@/components/forms/familiaProdutoTipologia/campoSeparadorForm.vue";
import GenericDataTable from "@/components/dataTable/GenericDataTable2.vue";
import ProdutoFilter from "@/components/filterDataTable/produtoFilter.vue";
import FamiliaFilter from "@/components/filterDataTable/familiaFilter.vue";
import TipologiaFilter from "@/components/filterDataTable/tipologiaFilter.vue";
export default {
  mixins: [permissionMixin],
  name: "appfamilia",
  components: {
    AppTable,
    AppForm,
    AppFilter,
    AppActionCard,
    AppProfileSearch,
    AppSearch,
    AppNotification,
    AppProdutoForm,
    AppFamiliaForm,
    AppTipologiaForm,
    AppFilterForm,
    AppPaginationTable,
    FamiliaFilter,
    ProdutoFilter,
    TipologiaFilter,
    CampoSeparadorForm,
    GenericDataTable,
  },
  data() {
    return {
      // Sem a valência "Gerir famílias e equipamentos" os ecrãs de Família,
      // Produto e Tipologia ficam só de consulta. O backend recusa as escritas
      // na mesma; isto evita mostrar botões que dariam 403.
      podeGerir: false,

      isFamiliaListVisible: false,
      isProdutoListVisible: false,
      isTipologiaListVisible: false,
      baseURl: process.env.VUE_APP_URL_BASE,
      status: 208,
      table_title: "Familias",
      mainTableData: [],
      propriedadesFamilia: [],
      familias: [],
      familia: {},
      familia_type: [],
      create_btn: false,
      familiaFormData: {},
      generic_table_data: [],
      showGenericTable: false,

      form_data: {},
      show_create_form: false,
      show_table: true,
      show_action_card: true,
      showProps: false,
      showRight: true,
      formTitle: "",
      showFamiliaForm: false,
      showProdutoForm: false,
      showTipologiaForm: false,

      familyProps: [],
      familyPropsData: {
        nome: "",
        tipo: "",
        familia_id: "",
        status: "",
      },

      familiaColumns: [
        {
          key: "nome",
          label: "Nome",
          sortable: true,
        },
        {
          key: "descricao",
          label: "Descrição",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          type: "badge",
          sortable: true,
        },
      ],
      produtoColumns: [
        {
          key: "produto",
          label: "Produto",
          sortable: true,
          maxWidth: 150,
        },
        {
          key: "familia",
          label: "Familia",
          sortable: true,
          maxWidth: 150,
        },
        {
          key: "tipo",
          label: "Tipo",
          sortable: true,
          type: "badge",
          maxWidth: 100,
        },
        {
          key: "descricao",
          label: "Descrição",
          sortable: true,
          maxWidth: 200,
        },
        {
          key: "status",
          label: "Status",
          type: "badge",
          sortable: true,
          maxWidth: 100,
        },
      ],
      tipologiaColumns: [
        {
          key: "nome",
          label: "Nome",
          sortable: true,
          maxWidth: 150,
        },
        {
          key: "familia.nome",
          label: "Familia",
          sortable: true,
          maxWidth: 150,
        },
        {
          key: "produto.nome",
          label: "Produto",
          sortable: true,
          maxWidth: 150,
        },
        {
          key: "tipo.nome",
          label: "Tipo",
          sortable: true,
          maxWidth: 150,
        },
        {
          key: "descricao",
          label: "Descrição",
          sortable: true,
          maxWidth: 200,
        },
        {
          key: "status",
          label: "Status",
          type: "badge",
          sortable: true,
          maxWidth: 100,
        },
      ],
      currentFilters: {},

      // Produto
      produtos: [],
      produtosByFamilia: [],
      criterioByFamilia: [],
      produtoPros: [],
      produtoFormData: {
        produto: "",
        descricao: "",
        foto: "",
        status: "ativo",
        opcoes: [],
      },
      produtoPropsData: {
        nome: "",
        tipo: "",
        produto_id: "",
        opcoes: [],
      },
      produto: {},
      showProdutoTable: false,
      showProdutoProps: false,
      showSparesForm: false,
      sparesData: {},
      newSpareForm: {
        produto: "",
        potenciacaoAbsoluta: 0,
        potenciacaoRelativa: 0,
      },
      Spares: [
        {
          id: 0,
          produto: "",
          potenciacaoAbsoluta: 0,
          potenciacaoRelativa: 0,
        },
      ],
      updateSpare: false,
      sparesByFamilia: [],
      produtoToExclude: "",
      sparesByProduto: [],
      veBtnCreate: false,

      servicos: [],
      ServicoProduto: [],
      servicoToUpdate: {
        tempo_medio: 0,
      },
      showServicoTable: false,
      showServicoData: false,
      familiaSelected: {
        id: 0,
      },

      // Campos de Separadores
      separadores: [],
      CamposSeparadores: [],
      showCamposSeparadoresTable: false,
      showCamposSeparadoresForm: false,
      mode: "create",
      initialData: {},

      // Tipologia

      tipologias: [],
      tipologiaFormTitle: "",
      tipologiaTableTitle: "Tipologia",
      showTipologiaTable: false,
      tipologiaFormData: {},
      marcas: [],
      medidas: [],
      tipos: [],
      set_data: {
        familiaSelected: {
          id: 0,
        },
        produtoSelected: {
          id: 0,
        },
        medidaSelected: {
          id: 0,
        },
        tipoSelected: {
          id: 0,
        },
      },

      // filtros
      filtroData: {},
      show_form_filter: false,
      selectedFiltro: "",
      filtroOptions: [],
      tabela: "familia",
      refresh_table: false,
      showFamiliaFilter: false,
      showProdutoFilter: false,
      showTipologiaFilter: false,
      filter_familia_data: [],
      filter_produto_data: [],
      filter_tipologia_data: [],
      familia_url: "familia",
      produto_url: "produto",
      tipologia_url: "tipologia",
    };
  },
  computed: {
    showOpcoes() {
      return this.produtoPropsData.tipo === "select";
    },

    filteredSparesByFamilia() {
      // Filter out the sparesByFamilia array to exclude the produtoToExclude
      return this.sparesByFamilia.filter(
        (spare) => spare.produto !== this.produtoToExclude,
      );
    },
  },

  async created() {
    this.podeGerir = await podeGerirFamiliasEquipamentos();
    this.getFamilias();
    this.getProdutos();
    this.getTipologias();
    //this.getfamiliaType()
  },
  mounted() {
    this.handleViewQuery();
  },
  methods: {
    handleViewQuery() {
      const view = this.$route.query.view;
      if (view === "produto") {
        this.triggerAction({ action: "show_produto" });
      } else if (view === "tipologia") {
        this.triggerAction({ action: "show_tipologia" });
      } else {
        this.triggerAction({ action: "show_familia" });
      }
    },
     updateFilters(filters) {
      this.currentFilters = { ...filters };
      this.$refs.dataTableRef.refresh();
    },
    verifyFormSpares() {
      const isPotenciacaoValid =
        this.newSpareForm.potenciacaoAbsoluta !== 0 ||
        this.newSpareForm.potenciacaoRelativa !== 0;
      const isProdutoSelected = this.newSpareForm.produto !== "";
      const isProdutoNotInSpares = !this.sparesByProduto.some(
        (spare) => spare.nome === this.newSpareForm.produto.produto,
      );

      this.veBtnCreate =
        isPotenciacaoValid && isProdutoSelected && isProdutoNotInSpares;
    },

    set_filter(data, table) {
      const isEmptyObject = (obj) => {
        return !obj || typeof obj !== "object" || Object.keys(obj).length === 0;
      };

      // Normalize table name to lowercase for keys like 'familia', 'produto', etc.
      const tableKey = this.table_title.toLowerCase().slice(0, -1); // "Familias" => "familia"

      // Dynamically set URL and filter variable names
      const urlKey = `${tableKey}_url`; // e.g., "familia_url"
      const filterKey = `filter_${tableKey}_data`; // e.g., "filter_familia_data"

      // Fallbacks in case of invalid table names
      if (!(urlKey in this) || !(filterKey in this)) {
        console.warn(`Invalid table name: ${this.table_title}`);
        return;
      }

      if (isEmptyObject(data)) {
        this[urlKey] = tableKey;
        this[filterKey] = JSON.parse(JSON.stringify(data));
        this.showFamiliaFilter = false;
        this.refresh = true;
        return;
      }

      this[urlKey] = `${tableKey}/tablefilter`;
      this[filterKey] = JSON.parse(JSON.stringify(data));
      this.showFamiliaFilter = false;
      this.showProdutoFilter = false;
      this.showTipologiaFilter = false;
      this.refresh = true;
    },

    checkAndResetRefreshTable() {
      if (this.refresh_table === true) {
        this.refresh_table = false;
      }
    },

    closeFilterForm() {
      this.show_form_filter = false;
    },
    checkTable(table, response) {
      if (table === "familia") {
        this.familias = response.data.data;
        this.show_table = true;
        this.showProdutoTable = false;
        this.showTipologiaTable = false;
      } else if (table === "produto") {
        this.produtos = response.data.data;
        this.showProdutoTable = true;
        this.show_table = false;
        this.showTipologiaTable = false;
      } else if (table === "tipologia") {
        this.tipologias = response.data.data;
        this.showTipologiaTable = true;
        this.show_table = false;
        this.showProdutoTable = false;
      }
    },
    dataName() {
      if (this.tabela === "familia") {
        this.getFamilias();
        this.table_title = "Familias";
        this.show_table = true;
        this.showProdutoTable = false;
        this.showTipologiaTable = false;
      } else if (this.tabela === "produto") {
        this.getProdutos();
        this.showProdutoTable = true;
        this.show_table = false;
        this.showTipologiaTable = false;
        this.table_title = "Produtos";
      } else if (this.tabela === "tipologia") {
        this.getTipologias();
        this.table_title = "Tipologia";
        this.showTipologiaTable = true;
        this.show_table = false;
        this.showProdutoTable = false;
      }
    },
    getFamilias() {
      axios.get(`${this.baseURl}/api/v1/familia/`).then((res) => {
        this.familias = res.data.data.sort((a, b) => a.id - b.id);
        this.familias.forEach((familia) => {
          delete familia.foto;
        });
      });
    },
    async getSpares() {
      if (this.familiaSelected.id !== 0) {
        try {
          const res = await axios.get(
            `${this.baseURl}/api/v1/produto/s/familia_id/${this.familiaSelected.id}/?exact=true`,
          );
          this.sparesByFamilia = res.data.data;
        } catch (error) {
          console.error("Error fetching spares:", error);
          this.sparesByFamilia = [];
        }
      }
    },
    async getProdutosByFamilia(familiaId) {
      try {
        const res = await axios.get(
          `${this.baseURl}/api/v1/produto/s/familia_id/${familiaId}/?exact=true`,
        );
        this.produtosByFamilia = res.data.data;
      } catch (error) {
        console.error("Error fetching spares:", error);
        this.produtosByFamilia = [];
      }
    },
    async getSparesByProduto(produtoId) {
      try {
        const res = await axios.get(
          `${this.baseURl}/api/v1/spare/s/produto_id/${produtoId}/?exact=true`,
        );
        this.sparesByProduto = res.data.data;
      } catch (error) {
        console.error("Error fetching spares:", error);
        this.sparesByProduto = [];
      }
    },

    showFamily(table) {
      if (table === "propriedades") {
        this.showProps = true;
        this.showGenericTable = true;
        this.show_table = true;
        this.formTitle = "Criar Familia";
        this.generic_table_title = "Propriedades";
        this.showRight = false;
        this.generic_table_data = this.propriedadesFamilia;
      } else if (table === "produto") {
        this.showProps = false;
        this.show_table = true;
        this.generic_table_title = "Produtos";
        this.form_title = "Criar Produtooo";
        this.showGenericTable = true;
        this.showRight = false;
        this.generic_table_data = this.produtosByFamilia;
      } else if (table === "tpRejeicao") {
        this.showProps = false;
        this.showGenericTable = true;
        this.show_table = true;
        this.generic_table_title = "Critérios Rejeição";
        this.showRight = false;
        this.getTpRejeicao(this.familiaFormData.id);
      }
    },

    async upload_img(formData, object) {
      if (formData.newFoto) {
        try {
          const response = await axios.post(
            `${this.baseURl}/api/v1/${object}/editar/foto/${formData.id}/`,
            formData.newFoto,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          );
          const filePath = response.data.filePath;
          //this.formData.foto = filePath;
          // await this.get_imagem(formData.id);
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
    },

    create_OnClick() {
      this.show_create_form = true;
    },

    update_OnClick() {
      console.log("button update clicked");
    },
    closeForm() {
      this.showServicoTable = false;
      this.show_create_form = false;
      this.showFamiliaForm = false;
      this.showProdutoForm = false;
      this.showTipologiaForm = false;
      this.showServicoTable = false;
      this.showSparesForm = false;
      this.showProps = false;
      this.showGenericTable = false;
      this.showProdutoProps = false;
      this.familiaFormData = {};
      this.familyProps = [];
      this.familyPropsData = {};
      this.produtoPros = [];
      this.generic_table_data = [];
      this.ServicoProduto = [];
      this.showRight = true;
      this.produtoFormData = {};
      this.familiaSelected = {};
      this.tipologiaFormData = {};
      this.set_data = {
        familiaSelected: {
          id: 0,
        },
        produtoSelected: {
          id: 0,
        },
        medidaSelected: {
          id: 0,
        },
        tipoSelected: {
          id: 0,
        },
      };
    },
    closeProps() {
      this.showProdutoProps = false;
      this.showProps = false;
      this.showGenericTable = false;
      this.showRight = true;
      this.showSparesForm = false;
      this.produtoPropsData = {
        nome: "",
        tipo: "",
        produto_id: "",
        opcoes: [],
      };
    },
    close_table() {
      this.show_table = false;
      this.showProdutoTable = false;
      this.showTipologiaTable = false;
    },
    select_generic_row(data) {
      if (this.generic_table_title && this.generic_table_title === "Familias") {
        this.familiaSelected = data;
        this.set_data.familiaSelected = data;
        this.showGenericTable = false;
        this.showRight = true;
        this.getProdutosByFamilia(this.set_data.familiaSelected.id);
        this.getSpares();
        // this.showGenericTable = false;
        // this.showRight = true;
      } else if (
        this.generic_table_title &&
        this.generic_table_title === "Serviços"
      ) {
        if (this.create_btn) {
          this.addOrUpdateServicoProduto(data);
        } else if (this.table_title === "Produtos") {
          const data_ = {
            produto_id: this.produtoFormData.id,
            tpServico_id: data.id,
            status: "ativo",
            descricao: data.nome,
          };

          this.createProdutServico(data_);
        } else if (this.table_title === "Tipologia") {
          const data_ = {
            tipologia_id: this.tipologiaFormData.id,
            tpServico_id: data.id,
            status: "ativo",
            descricao: data.nome,
          };
          this.createTipologiaServico(data_);
        }
      } else if (
        this.generic_table_title &&
        this.generic_table_title === "Spares"
      ) {
        if (this.create_btn) {
          // this.addOrUpdateSpares(data);
        } else {
          this.newSpareForm.potenciacaoAbsoluta = data.potenciacaoAbsoluta;
          this.newSpareForm.potenciacaoRelativa = data.potenciacaoRelativa;
          this.newSpareForm.nome = data.nome;
          this.newSpareForm.id = data.id;
          this.updateSpare = true;
          this.veBtnCreate = false;
        }
      } else if (
        this.generic_table_title &&
        this.generic_table_title === "Propriedades"
      ) {
        this.produtoPropsData = data;
      } else if (
        this.generic_table_title &&
        this.generic_table_title === "Marcas"
      ) {
        this.set_data.masrcaSelected = data;
      } else if (
        this.generic_table_title &&
        this.generic_table_title === "Produtos"
      ) {
        this.set_data.produtoSelected = data;
        this.showGenericTable = false;
        this.showRight = true;
      } else if (
        this.generic_table_title &&
        this.generic_table_title === "Medidas"
      ) {
        this.set_data.medidaSelected = data;
      } else if (
        this.generic_table_title &&
        this.generic_table_title === "Lista de Tipologias"
      ) {
        this.set_data.tipoSelected = data;
        this.showGenericTable = false;
        this.showRight = true;
      } else if (
        this.generic_table_title &&
        this.generic_table_title === "Separadores"
      ) {
        this.getCampoSeparadores(data.id);
      }

      this.familyPropsData = data;
    },
    close_generic_table() {
      this.showProps = false;
      this.showGenericTable = false;
      this.genericGenericTable = false;
      this.showServicoTable = false;
      this.showRight = true;
      this.showCamposSeparadoresForm = false;
      this.showCamposSeparadoresTable = false;
      this.showSparesForm = false;
      this.showServicoData = false;
    },
    triggerAction(action) {
      this.closeForm();
      this.closeFilter();

      if (action.action === "show_table") {
        // this.show_table = true;
        if (this.table_title === "Familias") {
          this.show_table = true;
        } else if (this.table_title === "Produtos") {
          this.showProdutoTable = true;
        } else if (this.table_title === "Tipologias") {
          this.showTipologiaTable = true;
        }
      }
      if (action.action === "show_familia") {
        this.closeForm();
        this.create_btn = false;
        this.showFamiliaForm = false;
        this.showProdutoForm = false;
        this.showProdutoProps = false;
        this.showTipologiaForm = false;
        this.showProdutoTable = false;
        this.showTipologiaTable = false;

        this.show_table = true;
        this.formTitle = "Criar Familia";
        this.showRight = true;
        this.showServicoTable = false;
        this.showProps = false;
        this.showGenericTable = false;
        this.showSparesForm = false;
        this.tabela = "familia";
        this.showCamposSeparadoresForm = false;
        this.showCamposSeparadoresTable = false;
        this.familiaFormData = {
          nome: "",
          descricao: "",
          foto: require("@/assets/car_logo.svg"),
          status: "ativo",
        };

        this.table_title = "Familias";
      }
      if (action.action === "show_produto") {
        this.closeForm();
        this.create_btn = false;
        this.showFamiliaForm = false;
        this.showProdutoForm = false;
        this.showProdutoProps = false;
        this.showTipologiaForm = false;
        this.show_table = false;
        this.showTipologiaTable = false;

        this.showProdutoTable = true;
        this.formTitle = "Criar Produto";
        this.showRight = true;
        this.showServicoTable = false;
        this.showProps = false;
        this.showGenericTable = false;
        this.showSparesForm = false;
        this.tabela = "produto";
        this.familiaFormData = {
          nome: "",
          descricao: "",
          foto: require("@/assets/car_logo.svg"),
          status: "ativo",
        };

        this.table_title = "Produtos";
        this.getServicos();
      }
      if (action.action === "show_tipologia") {
        this.closeForm();
        this.create_btn = false;
        this.showFamiliaForm = false;
        this.showProdutoForm = false;
        this.showProdutoProps = false;
        this.showTipologiaForm = false;
        this.showProdutoTable = false;
        this.show_table = false;
        this.showTipologiaTable = true;
        this.formTitle = "Criar Tipologia";
        this.showRight = true;
        this.showServicoTable = false;
        this.showProps = false;
        this.showGenericTable = false;
        this.showSparesForm = false;
        this.tabela = "tipologia";
        this.showCamposSeparadoresForm = false;
        this.showCamposSeparadoresTable = false;
        this.familiaFormData = {
          nome: "",
          descricao: "",
          foto: require("@/assets/car_logo.svg"),
          status: "ativo",
        };

        this.table_title = "Tipologias";
      }
      if (action.action === "create_produto") {
        this.formTitle = "Criar Produto";
        this.showProdutoForm = true;
        this.showFamiliaForm = false;
        this.showTipologiaForm = false;
        this.showProdutoTable = true;
        this.show_table = false;
        this.showTipologiaTable = false;
        this.create_btn = true;
        this.showProps = false;
        this.showGenericTable = false;
        this.showServicoTable = false;
        this.generic_table_data = [];
        this.showRight = true;
        this.tabela = "produto";
        this.table_title = "Produtos";

        this.familiaSelected = {
          id: 0,
        };
        (this.produtoFormData = {
          produto: "",
          descricao: "",
          foto: require("@/assets/hard_hat.svg"),
          status: "ativo",
        }),
          this.getServicos();
        this.produtoPropsData = {};
      }
      if (action.action === "create_familia") {
        this.closeForm();
        this.create_btn = true;
        this.showFamiliaForm = true;
        this.showProdutoForm = false;
        this.showProdutoProps = false;
        this.showTipologiaForm = false;
        this.showProdutoTable = false;
        this.show_table = true;
        this.formTitle = "Criar Familia";
        this.showRight = true;
        this.showServicoTable = false;
        this.showProps = false;
        this.showGenericTable = false;
        this.showSparesForm = false;
        this.tabela = "familia";
        this.familiaFormData = {
          nome: "",
          descricao: "",
          foto: require("@/assets/car_logo.svg"),
          status: "ativo",
        };

        this.table_title = "Familias";
      }
      if (action.action === "create_tipologia") {
        // Configura o formulário de nova tipologia
        this.create_btn = true; // Define que está no modo de criação
        this.showTipologiaForm = true; // Exibe o formulário de Tipologia
        this.showFamiliaForm = false; // Oculta formulário de Família
        this.showProdutoProps = false; // Oculta propriedades de Produto
        this.showProps = false; // Oculta propriedades
        this.showProdutoForm = false; // Oculta formulário de Produto
        this.showSparesForm = false; // Oculta formulário de Spares
        this.showRight = true; // Mostra a área direita
        this.showGenericTable = false; // Oculta tabelas genéricas
        this.tipologiaFormTitle = "Criar Tipologia"; // Define o título do formulário
        this.tabela = "tipologia"; // Define a tabela ativa como "tipologia"

        // Permanece mostrando a tabela ou lista de Tipologias
        this.showTipologiaTable = true;

        // Inicializa os dados para o formulário de Tipologia
        this.tipologiaFormData = {
          nome: "",
          descricao: "",
          foto: require("@/assets/hard_hat.svg"),
          status: "ativo",
        };

        // Carrega dados auxiliares
        this.getServicos();
        this.getMarcas();
        this.getMedidas();
        this.getTipos();
      }
      if (action.action === "criar_filtro") {
        this.show_form_filter = true;
      }
    },
    openSubForm(name) {
      console.log("Open Sub Form", name);
    },

    createFamilia(data) {
      axios
        .post(`${this.baseURl}/api/v1/familia/registrar/`, data)
        .then((res) => {
          toast.success("Familia criada com sucesso", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          // this.refresh_table = true;
          this.$refs.dataTableRef.refresh();
          this.createFamiliaProps(this.generic_table_data, res.data.data.id);
          data.id = res.data.data.id;
          this.upload_img(data, "familia");
          this.getFamilias();
          this.closeForm();
          this.show_table = true;
        })
        .catch((error) => {
          toast.error("Erro ao criar familia", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          console.error("Error posting data:", error);
        });
    },
    closeFilter(){
      this.showProdutoFilter = false;
      this.showFamiliaFilter = false;
      this.showTipologiaFilter = false;
    },
    async select(data) {
      this.showProps = false;
      this.showGenericTable = false;
      this.showRight = true;
      this.getFamiliaPropriedades(data.id);
      this.getProdutosByFamilia(data.id);
      const imgUrl = await this.get_imagem(data.id, "familia");

      await axios
        .get(`${this.baseURl}/api/v1/familia/${data.id}/`)
        .then((res) => {
          this.familia = res.data.data;
          this.familiaFormData = res.data.data;
          if (imgUrl) {
            this.familiaFormData.foto = imgUrl;
          } else {
            this.familiaFormData.foto = require("@/assets/car_logo.svg");
          }
        });
      this.passingData();
    },
    async get_imagem(id, object) {
      if (id == 0) return;
      try {
        const response = await axios.get(
          `${this.baseURl}/api/v1/${object}/foto/${id}/`,
          { responseType: "blob" },
        );
        // Create a local URL of the image
        // this.form_data.foto = URL.createObjectURL(new Blob([response.data]));
        if (response.status != 200) {
          return;
        }
        return URL.createObjectURL(new Blob([response.data]));
      } catch (error) {
        console.log(error);
      }
    },
    async getTpRejeicao(familyId) {
      try {
        const res = await axios.get(
          `${this.baseURl}/api/v1/tprejeicao/familia/${familyId}/`,
        );
        this.criterioByFamilia = res.data.data;
        this.generic_table_data = res.data.data;
      } catch (error) {
        console.error("Erro ao buscar Critérios Rejeição:", error);
        this.generic_table_data = [];
      }
    },

    passingData() {
      this.show_info = true;
      this.create_btn = false;
      this.showFamiliaForm = true;
      this.formTitle = "Editar Familia";
      this.familiaFormData = this.familia;
    },
    async updateFamilia(data) {
      axios
        .put(`${this.baseURl}/api/v1/familia/editar/${data.id}/`, data)
        .then((res) => {
          toast.success("Familia atualizada com sucesso", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          this.$refs.dataTableRef.refresh();
          this.upload_img(data, "familia");
          this.getFamilias();
          this.familia = data;
          this.form_data = {
            id: this.familia.id,
            nome: this.familia.nome,
            decricao: this.familia.decricao,
            tipo: this.familia.tipo,
            status: this.familia.status,
          };
          this.closeForm();
        })
        .catch((error) => {
          toast.error("Erro ao atualizar familia", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          console.error("Error posting data:", error);
        });
    },
    async disableEnable(data) {
      let url = "";
      let object = "";
      if (data.object === "familia") {
        object = "familia";
      } else if (data.object === "produto") {
        object = "produto";
      } else if (data.object === "tipologia") {
        object = "tipologia";
      }

      if (data.status === "ativo") {
        url = `${this.baseURl}/api/v1/${object}/eliminar/${data.id}/`;
      } else {
        url = `${this.baseURl}/api/v1/${object}/eliminar/${data.id}/?ativar=true&&loggedId=${loggedID}`;
      }

      try {
        // Make the POST request
        const message = data.status === "ativo" ? "desativado" : "ativado";
        const res = await axios.delete(url);
        toast.success(`${object.toUpperCase()} ${message} com sucesso`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.$refs.dataTableRef.refresh();
      } catch (error) {
        const message = data.status == "ativo" ? "desativar" : "ativar";
        const errorMsg =
          error.response?.data?.message ||
          `Erro ao ${message} ${object.toUpperCase()}`;

        toast.error(errorMsg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });

        console.error("Error posting prop data:", error);
      }

      if (object === "familia") {
        this.getFamilias();
      } else if (object === "produto") {
        this.getProdutos();
      } else if (object === "tipologia") {
        this.getTipologias();
      }

      this.closeForm();
    },
    remove(data) {
      axios
        .delete(`${this.baseURl}/api/v1/familia/eliminar/${data.id}/`)
        .then((res) => {
          this.getFamilias();
          this.show_info = false;
          this.closeForm();
        })
        .catch((error) => {
          console.error("Error posting data:", error);
        });
    },
    isFieldEmpty(obj, field) {
      return (
        !(field in obj) ||
        obj[field] === null ||
        obj[field] === undefined ||
        obj[field] === ""
      );
    },

    // Propriedades
    async createFamiliaProps(data, familiId) {
      if (data.familia_id) {
        try {
          // Make the POST request
          const res = await axios.post(
            `${this.baseURl}/api/v1/propriedadefamilia/registrar/`,
            data,
          );
          toast.success("Propriedade criada com sucesso", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          this.getFamiliaPropriedades(data.familia_id);
          this.resetFamilyPropsData();
        } catch (error) {
          console.error("Error posting prop data:", error);
          toast.error("Erro ao criar propriedade", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
      } else {
        for (let prop of data) {
          // Add familia_id to each object
          const postData = { ...prop, familia_id: familiId };
          try {
            // Make the POST request
            const res = await axios.post(
              `${this.baseURl}/api/v1/propriedadefamilia/registrar/`,
              postData,
            );
          } catch (error) {
            console.error("Error posting prop data:", error);
          }
        }
      }
    },

    async updateFamilyProps(data) {
      if (data.familia_id) {
        try {
          const res = await axios.put(
            `${this.baseURl}/api/v1/propriedadefamilia/editar/${data.id}/`,
            data,
          );
          // this.showProps = false;
          toast.success("Propriedade atualizada com sucesso", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          this.getFamiliaPropriedades(data.familia_id);
          this.resetFamilyPropsData();
        } catch (error) {
          toast.error("Erro ao atualizar propriedade", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          console.error("Error updating prop data:", error);
        }
      } else {
        console.log("Data props without famili:", data);
      }
    },
    async deleteFamilyProps(data) {
      const message = data.status === "ativo" ? "desativada" : "ativada";
      let url = "";
      if (data.status === "ativo") {
        url = `${this.baseURl}/api/v1/propriedadefamilia/eliminar/${data.id}/`;
      } else {
        url = `${this.baseURl}/api/v1/propriedadefamilia/eliminar/${data.id}/?ativar=true&&loggedId=${loggedID}`;
      }

      try {
        const res = await axios.delete(url);
        toast.success(`Propriedade ${message} com sucesso`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.getFamiliaPropriedades(data.familia_id);
        this.resetFamilyPropsData();
      } catch (error) {
        toast.error(`Erro ao ${message} Propriedade`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        console.error("Error deleting prop data:", error);
      }
    },
    async getFamiliaPropriedades(familiaId) {
      try {
        const res = await axios.get(
          `${this.baseURl}/api/v1/propriedadefamilia/s/familia_id/${familiaId}/?exact=true`,
        );
        if (res.data.data.length > 0) {
          this.propriedadesFamilia = res.data.data;
        }
      } catch (error) {
        console.error("Error fetching propriedades:", error);
        this.propriedadesFamilia = [];
      }
    },
    isPropExisting(nome, tipo) {
      return this.familyProps.some(
        (prop) => prop.nome === nome && prop.tipo === tipo,
      );
    },
    calculateNextId() {
      return this.familyProps.length === 0
        ? 1
        : Math.max(...this.familyProps.map((prop) => prop.id)) + 1;
    },
    createNewProp(id, data) {
      return { id, ...data };
    },
    resetFamilyPropsData() {
      this.familyPropsData = {};
    },
    createFamilyProps() {
      if (this.familiaFormData && this.familiaFormData.id) {
        this.familyPropsData.familia_id = this.familiaFormData.id;
        this.createFamiliaProps(this.familyPropsData);
      } else {
        if (
          this.isFieldEmpty(this.familyPropsData, "nome") ||
          this.isFieldEmpty(this.familyPropsData, "tipo")
        ) {
          console.log("Empty Field");
          return;
        }

        if (
          this.isPropExisting(
            this.familyPropsData.nome,
            this.familyPropsData.tipo,
          )
        ) {
          return;
        }

        const nextId = this.calculateNextId();
        const newFamilyPropsData = this.createNewProp(
          nextId,
          this.familyPropsData,
        );

        this.familyProps.push(newFamilyPropsData);
        this.generic_table_data = this.familyProps;
        this.status = 201;

        this.resetFamilyPropsData();
      }
    },
    async syncOpcoes(propriedadeId, opcoesUI = []) {
      // força opcoesUI a ser um array
      const ui = Array.isArray(opcoesUI) ? opcoesUI : [];

      // 1) busca as opções atuais do servidor
      const { data: originais } = await axios.get(
        `${this.baseURl}/api/v1/propriedadeproduto_opcao/${propriedadeId}/opcoes/`,
      );

      // 2) delete as que foram removidas no formulário
      for (const o of originais) {
        if (!ui.find((x) => x.id === o.id)) {
          await axios.delete(
            `${this.baseURl}/api/v1/propriedadeproduto_opcao/${o.id}/`,
          );
        }
      }

      // 3) crie as novas (sem id)
      for (const o of ui.filter((x) => !x.id)) {
        await axios.post(
          `${this.baseURl}/api/v1/propriedadeproduto_opcao/${propriedadeId}/opcoes/`,
          { valor_label: o.valor_label },
        );
      }

      // 4) atualize as que mudaram de label
      for (const o of ui.filter((x) => x.id)) {
        const original = originais.find((x) => x.id === o.id);
        if (original && original.valor_label !== o.valor_label) {
          await axios.put(
            `${this.baseURl}/api/v1/propriedadeproduto_opcao/${o.id}/`,
            { valor_label: o.valor_label },
          );
        }
      }
    },

    // Produto
    async createProduto(data) {
      try {
        // `foto` is only a UI preview URL; photos are stored on disk, not in the column.
        const payload = { ...data };
        delete payload.foto;
        const res = await axios.post(
          `${this.baseURl}/api/v1/produto/registrar/`,
          payload,
        );
        data.id = res.data.data.id;
        this.upload_img(data, "produto");
        this.createProdutProps(this.produtoPros, res.data.data.id);
        this.createProdutServico(this.ServicoProduto, res.data.data.id);
        this.createProdutSpares(this.Spares, res.data.data.id);
        this.getProdutos();
        this.closeForm();
        this.$refs.dataTableRef.refresh();
        toast.success("Produto criado com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      } catch (error) {
        toast.error("Erro ao criar Produto", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        console.error("Error posting data:", error);
      }
    },
    async updateProduto(data) {
      this.upload_img(data, "produto");
      const payload = { ...data };
      delete payload.foto;
      await axios
        .put(`${this.baseURl}/api/v1/produto/editar/${data.id}/`, payload)
        .then((res) => {
          this.getProdutos();
          this.produto = data;
          this.form_data = {
            id: this.produto.id,
            produto: this.produto.produto,
            descricao: this.produto.descricao,
            foto: this.produto.foto,
            status: this.produto.status,
          };
          toast.success("Produto atualizado com sucesso", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          this.$refs.dataTableRef.refresh();
          this.closeForm();
        })
        .catch((error) => {
          toast.error("Erro ao atualizar Produto", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          console.error("Error posting data:", error);
        });
    },
    showProduto(table) {
      if (table === "propriedades") {
        this.showRight = false;
        this.showProdutoProps = true;
        this.showGenericTable = true;
        this.generic_table_title = "Propriedades";
        this.generic_table_data = this.produtoPros;
        // this.generic_table_data = this.produtoPros;
      } else if (table === "familia") {
        (this.generic_table_data = []), (this.showGenericTable = true);
        this.showRight = false;
        // this.showProdutoTable = true;
        this.generic_table_title = "Familias";
        this.generic_table_data = this.familias;
      } else if (table === "servicos") {
        (this.generic_table_data = []), (this.showRight = false);
        this.showServicoTable = true;
        this.generic_table_data = this.servicos;
        this.generic_table_title = "Serviços";
        this.showGenericTable = true;
        if (this.create_btn) {
          this.ServicoProduto = [
            {
              id: 0,
              nome: "N/A",
              tempo_medio: 0,
              compraAtual: 0,

              status: "ativo",
            },
          ];
        }
      } else if (table === "spares") {
        (this.generic_table_data = []), (this.showRight = false);
        this.generic_table_title = "Spares";
        this.showSparesForm = true;
        this.showGenericTable = true;
        this.generic_table_data = this.sparesByProduto;
      } else if (table === "separadores") {
        this.getSeparadores();
        this.showRight = false;
      }
    },
    async getProdutos() {
      await axios.get(`${this.baseURl}/api/v1/produto/`).then((res) => {
        this.produtos = res.data.data.sort((a, b) => a.id - b.id);
        this.produtos = this.produtos.map(
          ({ foto, familia_id, ...rest }) => rest,
        );
      });
    },
    async getProdutoPropriedades(produtoId) {
      try {
        const res = await axios.get(
          `${this.baseURl}/api/v1/propriedadeproduto/s/produto_id/${produtoId}/?exact=true`,
        );
        if (res.data.data.length > 0) {
          this.produtoPros = res.data.data;
          this.status = 200;
        }
      } catch (error) {
        console.error("Error fetching propriedades:", error);
        this.produtoPros = [];
        // Handle the error appropriately
        // For example, you might want to set generic_table_data to an empty array
        // or show an error message to the user
      }
    },
    findFamiliaById(familiaId) {
      return this.familias.find((familia) => familia.id === familiaId);
    },
    async selectP(data) {
      // this.closeForm();
      this.produtoPropsData = {};
      this.showCamposSeparadoresForm = false;
      this.showCamposSeparadoresTable = false;

      this.showGenericTable = false;
      this.showProdutoProps = false;
      this.showRight = true;
      this.showSparesForm = false;
      this.showServicoTable = false;
      let imgUrl = await this.get_imagem(data.id, "produto");
      if (!imgUrl) {
        imgUrl = require("@/assets/hard_hat.svg");
      }
      axios.get(`${this.baseURl}/api/v1/produto/${data.id}/`).then((res) => {
        this.produto = res.data.data;
        this.produtoFormData = {
          id: this.produto.id,
          produto: this.produto.produto,
          descricao: this.produto.descricao,
          foto: imgUrl,
          status: this.produto.status,
          opcoes: this.produto.opcoes || [],
        };
        this.familiaSelected = this.findFamiliaById(res.data.data.familia_id);
        this.formTitle = "Editar Produto";
        this.getProdutoPropriedades(data.id);
        this.getServicosByProduto(data.id);
        this.getSparesByProduto(data.id);
        this.getSpares();
        this.produtoToExclude = this.produtoFormData.produto;
        this.showProdutoForm = true;
        this.create_btn = false;
      });
    },
    addOpcao() {
      if (this.produtoPropsData.opcoes === undefined) {
        this.produtoPropsData.opcoes = [];
      }
      this.produtoPropsData.opcoes.push({
        id: null, // null = ainda não existe no servidor
        valor_label: "",
      });
    },
    removeOpcao(idx) {
      this.produtoPropsData.opcoes.splice(idx, 1);
    },
    async getServicos() {
      axios.get(`${this.baseURl}/api/v1/tpservico/`).then((res) => {
        this.servicos = res.data.data.sort((a, b) => a.id - b.id);
        this.status = 200;
      });
    },
    async getServicosByProduto(produtoId) {
      axios
        .get(
          `${this.baseURl}/api/v1/produto_tpservico/?produto_id=${produtoId}`,
        )
        .then((res) => {
          this.ServicoProduto = res.data.data.sort((a, b) => a.id - b.id);
          if (this.ServicoProduto.length > 0) {
            this.ServicoProduto = this.ServicoProduto.map(
              ({ tpServico_id, produto_id, ...rest }) => rest,
            );
            delete this.ServicoProduto[0].tpServico_id;
            delete this.ServicoProduto[0].produto_id;
          }
        });
    },

    apagaServicoProduto() {
      this.showServicoData = false;
    },

    addOrUpdateTempoMedio() {
      this.ServicoProduto[0].tempoMedio = this.tempoMedio;
    },
    async updateTempoMedio() {
      if (this.create_btn) {
        const indexOfServico = this.ServicoProduto.findIndex(
          (item) => item.id === this.servicoToUpdate.id,
        );
        if (indexOfServico !== -1) {
          this.ServicoProduto[indexOfServico].tempo_medio =
            this.servicoToUpdate.tempo_medio;
        }
      } else {
        try {
          if (this.table_title === "Produtos") {
            const postData = {
              produtoTpServico: this.servicoToUpdate,
            };
            const res = await axios.put(
              `${this.baseURl}/api/v1/produto_tpservico/editar/${this.servicoToUpdate.id}/`,
              postData,
            );
            this.getServicosByProduto(this.produtoFormData.id);
            this.resetForm();
          } else if (this.table_title === "Tipologia") {
            const postData = {
              tipologiaTpServico: this.servicoToUpdate,
            };
            const res = await axios.put(
              `${this.baseURl}/api/v1/tipologia_tpservico/editar/${this.servicoToUpdate.id}/`,
              postData,
            );
            this.getServicoTipologia(this.tipologiaFormData.id);
          }
        } catch (error) {
          console.error("Error updating spare:", error);
        }
      }
      this.showServicoData = false;
    },
    addOrUpdateServicoProduto(data) {
      let copyServicoProduto = { ...data, tempo_medio: 0 };
      const existingIndex = this.ServicoProduto.findIndex(
        (item) => item.id === data.id,
      );

      if (existingIndex === -1) {
        const indexIdZero = this.ServicoProduto.findIndex(
          (item) => item.id === 0,
        );
        if (indexIdZero !== -1) {
          this.ServicoProduto.splice(indexIdZero, 1);
        }

        this.ServicoProduto.push(copyServicoProduto);
      } else {
        console.log("Object already exists in the array");
      }
    },
    addOrUpdateSpares(data) {
      const existingIndex = this.Spares.findIndex(
        (item) => item.nome === data.nome,
      );

      if (existingIndex === -1) {
        const indexIdZero = this.Spares.findIndex((item) => item.id === 0);
        if (indexIdZero !== -1) {
          this.Spares.splice(indexIdZero, 1);
        }

        this.Spares.push(data);
      } else {
        console.log("Object already exists in the array");
      }
    },
    spareNameExists(newSpareName) {
      return this.Spares.some((spare) => spare.produto === newSpareName);
    },
    deleteSpareById(spareId) {
      this.Spares = this.Spares.filter((spare) => spare.id !== spareId);
    },

    createSpare() {
      if (this.create_btn) {
        // Access newSpareForm using this.newSpareForm
        if (this.spareNameExists(this.newSpareForm.produto.produto)) {
          toast.success(
            `Spare já existe ${this.newSpareForm.produto.produto}`,
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 1000,
            },
          );
        } else {
          const highestId = this.Spares.reduce(
            (max, spare) => Math.max(spare.id, max),
            0,
          );
          const newSpare = {
            id: highestId + 1,
            ...this.newSpareForm,
          };
          this.deleteSpareById(0);
          this.Spares.push(newSpare);
          this.resetForm();
        }
      } else {
        const postData = {
          produto_id: this.produtoFormData.id,
          potenciacaoAbsoluta: this.newSpareForm.potenciacaoAbsoluta,
          potenciacaoRelativa: this.newSpareForm.potenciacaoRelativa,
          nome: this.newSpareForm.produto.produto,
          produt_spares_id: this.newSpareForm.produto.id,
          status: "ativo",
        };
        this.createProdutSpares(postData);
        this.generic_table_data = this.sparesByProduto;
        this.resetForm();
      }
    },
    async updateSpares() {
      try {
        const res = await axios.put(
          `${this.baseURl}/api/v1/spare/editar/${this.newSpareForm.id}/`,
          this.newSpareForm,
        );
        this.getSparesByProduto(this.produtoFormData.id);
        this.resetForm();
        this.updateSpare = false;
      } catch (error) {
        console.error("Error updating spare:", error);
      }
    },
    atualizaSel() {
      this.resetForm();
      this.updateSpare = false;
    },
    async deleteSpares() {
      try {
        const res = await axios.delete(
          `${this.baseURl}/api/v1/spare/eliminar/${this.newSpareForm.id}/`,
        );
        this.getSparesByProduto(this.produtoFormData.id);
        this.resetForm();
        this.updateSpare = false;
      } catch (error) {
        console.error("Error deleting spare:", error);
      }
    },
    resetForm() {
      this.newSpareForm = {
        nome: "",
        potenciacaoAbsoluta: 0,
        potenciacaoRelativa: 0,
        produto: {
          id: 0,
          produto: "",
        },
      };
    },
    createProdutoProps() {
      if (this.produtoFormData && this.produtoFormData.id) {
        this.produtoPropsData.produto_id = this.produtoFormData.id;
        this.createProdutProps(this.produtoPropsData);
      } else {
        if (
          this.isFieldEmpty(this.produtoPropsData, "nome") ||
          this.isFieldEmpty(this.produtoPropsData, "tipo")
        ) {
          return;
        }
        if (
          this.isPropExisting_(
            this.produtoPropsData.nome,
            this.produtoPropsData.tipo,
          )
        ) {
          return;
        }

        const nextId = this.calculateNextId_();
        const newProdutoPropsData = this.createNewProp(
          nextId,
          this.produtoPropsData,
        );
        this.produtoPros.push(newProdutoPropsData);
        this.generic_table_data = this.produtoPros;
        this.status = 201;

        this.produtoPropsData = {};
      }
    },

    isPropExisting_(nome, tipo) {
      return this.produtoPros.some(
        (prop) => prop.nome === nome && prop.tipo === tipo,
      );
    },

    calculateNextId_() {
      return this.produtoPros.length === 0
        ? 1
        : Math.max(...this.produtoPros.map((prop) => prop.id)) + 1;
    },
    async createProdutProps(data, produtoId) {
      const payload = {
        ...data,
        opcoes: data.tipo === "select" ? data.opcoes : [],
      };

      if (data.produto_id) {
        try {
          // usa o payload em vez de data
          const res = await axios.post(
            `${this.baseURl}/api/v1/propriedadeproduto/registrar/`,
            payload,
          );
          if (data.tipo === "select") {
            await this.syncOpcoes(res.data.data.id || 0, payload.opcoes);
          }
          // await this.getProdutoPropriedades(data.produto_id);
        } catch (error) {
          console.error("Error posting prop data:", error);
        }
      } else {
        for (let prop of data) {
          // prop já tem valor_label, id, etc; só precisa do produto_id
          const postData = {
            ...prop,
            produto_id: produtoId,
            opcoes: prop.tipo === "select" ? prop.opcoes : [],
          };

          try {
            const res = await axios.post(
              `${this.baseURl}/api/v1/propriedadeproduto/registrar/`,
              postData,
            );
            if (postData.tipo === "select" && res.data.data.id) {
              await this.syncOpcoes(res.data.data.id || 0, postData.opcoes);
            }
          } catch (error) {
            console.error("Error posting prop data:", error);
          }
        }
      }
      this.getProdutoPropriedades(this.produtoFormData.id);
      this.produtoPropsData = {
        nome: "",
        tipo: "",
        produto_id: produtoId,
        opcoes: [],
      };
    },

    async updateProdutoProps(data) {
      // idem: monta o payload garantindo 'opcoes' para select
      const payload = {
        ...data,
        opcoes: data.tipo === "select" ? data.opcoes : [],
      };

      if (data.produto_id) {
        try {
          const res = await axios.put(
            `${this.baseURl}/api/v1/propriedadeproduto/editar/${data.id}/`,
            payload,
          );
          await this.getProdutoPropriedades(data.produto_id);
        } catch (error) {
          console.error("Error updating prop data:", error);
        }
      } else {
        console.log("Data props without produto:", data);
      }
      // Sincroniza opções quando for select
      if (data.tipo === "select") {
        await this.syncOpcoes(data.id, this.produtoPropsData.opcoes);
      }

      // Recarrega e limpa
      this.getProdutoPropriedades(data.produto_id);
      this.produtoPropsData = {
        nome: "",
        tipo: "",
        produto_id: data.produto_id,
        opcoes: [],
      };
    },

    async deleteProdutoProps(data) {
      try {
        const res = await axios.delete(
          `${this.baseURl}/api/v1/propriedadeproduto/eliminar/${data.id}/`,
        );
        this.getProdutoPropriedades(data.produto_id);
        this.produtoPropsData = {};
      } catch (error) {
        console.error("Error deleting prop data:", error);
      }
    },
    async saveIfUniqueDescricao(newData) {
      const toSend = {
        produtoTpServico: newData,
      };
      const exists = this.ServicoProduto.some(
        (servico) => servico.descricao === newData.descricao,
      );
      if (!exists) {
        try {
          const res = await axios.post(
            `${this.baseURl}/api/v1/produto_tpservico/registrar/`,
            toSend,
          );
          if (res.data) {
            await this.getServicosByProduto(newData.produto_id);
            this.produtoPropsData = {};
          }
        } catch (error) {
          console.error("Error posting servico data:", error);
        }
      } else {
        console.log("Servico already exists");
      }
    },

    async createProdutServico(data, produtoId) {
      if (data.produto_id) {
        this.saveIfUniqueDescricao(data);
        this.getServicosByProduto(data.produto_id);
      } else {
        for (let servico of data) {
          const postData = {
            produtoTpServico: {
              produto_id: produtoId,
              descricao: servico.nome,
              tpServico_id: servico.id,
              tempo_medio: servico.tempo_medio,
            },
          };

          try {
            const res = await axios.post(
              `${this.baseURl}/api/v1/produto_tpservico/registrar/`,
              postData,
            );
            if (res.data) {
              this.getServicosByProduto(produtoId);
              this.produtoPropsData = {};
            }
          } catch (error) {
            console.error("Error posting prop data:", error);
          }
        }
      }
    },
    SelectServicoProduto(data) {
      this.servicoToUpdate = data;
      this.showServicoData = true;

      this.$nextTick(() => {
        this.$refs.tempoMedioInput.focus();
      });
    },
    async createProdutSpares(data, produtoId) {
      if (data.produto_id) {
        try {
          const res = await axios.post(
            `${this.baseURl}/api/v1/spare/registrar/`,
            data,
          );
          this.getSparesByProduto(data.produto_id);
        } catch (error) {
          console.error("Error posting servico data:", error);
        }
      } else {
        for (let spares of data) {
          const { produto, ...rest } = spares;
          // Modify the object to include produto_id and nome, keeping the rest of the data the same
          const postData = {
            ...rest, // Spread operator to copy existing properties
            produto_id: produtoId, // Add or overwrite produto_id
            nome: spares.produto, // Add or overwrite nome
            potenciacaoAbsoluta:
              rest.potenciacaoAbsoluta === "" ? 0 : rest.potenciacaoAbsoluta,
            potenciacaoRelativa:
              rest.potenciacaoRelativa === "" ? 0 : rest.potenciacaoRelativa,
            produt_spares_id: spares.produt_spares_id,
          };

          try {
            // Make the POST request
            const res = await axios.post(
              `${this.baseURl}/api/v1/spare/registrar/`,
              postData,
            );
          } catch (error) {
            console.error("Error posting spare data:", error);
          }
        }
      }
    },

    // Tipologia

    async getTipologias() {
      try {
        const res = await axios.get(`${this.baseURl}/api/v1/tipologia/`);
        this.tipologias = res.data.data;

        this.tipologias.forEach((tipologia) => {
          delete tipologia.foto;
        });
        // this.tipologias = this.tipologias.map(({ foto, ...rest }) => rest);
      } catch (error) {
        console.error("Error fetching Tipologias:", error);
        this.tipologias = [];
      }
    },
    async getMarcas() {
      try {
        const res = await axios.get(`${this.baseURl}/api/v1/tpmarca/`);
        this.marcas = res.data.data;
      } catch (error) {
        console.error("Error fetching marcas:", error);
        this.marcas = [];
      }
    },
    async getMedidas() {
      try {
        const res = await axios.get(`${this.baseURl}/api/v1/tpmedida/`);
        this.medidas = res.data.data;
      } catch (error) {
        console.error("Error fetching medidas:", error);
        this.medidas = [];
      }
    },
    async getTipos() {
      try {
        const res = await axios.get(`${this.baseURl}/api/v1/tptipologia/`);
        this.tipos = res.data.data;
      } catch (error) {
        console.error("Error fetching tipos:", error);
        this.tipos = [];
      }
    },
    async createTipologiaServico(data, tipologiaId) {
      if (data.tipologia_id) {
        this.saveIfUniqueDescricaoTipologia(data);
        this.getServicoTipologia();
      } else {
        for (let servico of data) {
          // Add familia_id to each object
          const postData = {
            tipologiaTpServico: {
              tipologia_id: tipologiaId,
              descricao: servico.nome,
              tpServico_id: servico.id,
              tempo_medio: servico.tempo_medio,
            },
          };
          try {
            const res = await axios.post(
              `${this.baseURl}/api/v1/tipologia_tpservico/registrar/`,
              postData,
            );
          } catch (error) {
            console.error("Error posting prop data:", error);
          }
        }
      }
    },
    saveIfUniqueDescricaoTipologia(newData) {
      const toSend = {
        tipologiaTpServico: newData,
      };
      const exists = this.ServicoProduto.some(
        (servico) => servico.descricao === newData.descricao,
      );
      if (!exists) {
        try {
          const res = axios.post(
            `${this.baseURl}/api/v1/tipologia_tpservico/registrar/`,
            newData,
          );
          this.getServicoTipologia(newData.tipologia_id);
          // this.produtoPropsData = {};
        } catch (error) {
          console.error("Error posting servico data:", error);
        }
      } else {
        console.log("Servico already exists");
      }
    },
    showTipologia(table) {
      if (table === "familias") {
        this.generic_table_data = this.familias;
        this.generic_table_title = "Familias";
        this.showGenericTable = true;
        this.showRight = false;
      } else if (table === "marcas") {
        this.generic_table_data = this.marcas;
        this.generic_table_title = "Marcas";
        this.showGenericTable = true;
        this.showRight = false;
      } else if (table === "produtos") {
        this.generic_table_data = this.produtosByFamilia;
        this.generic_table_title = "Produtos";
        this.showGenericTable = true;
        this.showRight = false;
      } else if (table === "tpRejeicao") {
        this.generic_table_data = this.criterioByFamilia;
        this.generic_table_title = "Tipo rejeição";
        this.showGenericTable = true;
        this.showRight = false;
      } else if (table === "medidas") {
        this.generic_table_data = this.medidas;
        this.generic_table_title = "Medidas";
        this.showGenericTable = true;
        this.showRight = false;
      } else if (table === "tipos") {
        this.generic_table_data = this.tipos;
        this.generic_table_title = "Lista de Tipologias";
        this.showGenericTable = true;
        this.showRight = false;
      } else if (table === "servicos") {
        this.generic_table_data = this.servicos;

        this.showServicoTable = true;
        this.showServicoData = false;
        this.generic_table_title = "Serviços";
        this.showGenericTable = true;
        this.showRight = false;
      }
    },
    async createTipologia(data) {
      const postData = {
        nome: data.nome,
        descricao: data.descricao,
        familia_id: data.familiaSelected.id,
        produto_id: data.produtoSelected.id,
        tpTipologia_id: data.tipoSelected.id,
      };
      try {
        const res = await axios.post(
          `${this.baseURl}/api/v1/tipologia/registrar/`,
          postData,
        );
        data.id = res.data.data.id;
        this.upload_img(data, "tipologia");
        this.createTipologiaServico(this.ServicoProduto, res.data.data.id);
        this.getTipologias();
        this.$refs.dataTableRef.refresh();
        toast.success("Tipologia criada com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.closeForm();
      } catch (error) {
        toast.error("Erro ao criar Tipologia", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        console.error("Error posting tipologia:", error);
      }
    },
    async getServicoTipologia() {
      try {
        const res = await axios.get(
          `${this.baseURl}/api/v1/tipologia_tpservico/?tipologia_id=${this.tipologiaFormData.id}`,
        );
        res.data.data = res.data.data.map(
          ({ tpServico_id, tipologia_id, ...rest }) => rest,
        );
        if (res.data.data.length > 0) {
          this.ServicoProduto = res.data.data;
        } else {
          this.ServicoProduto = [
            {
              id: 0,
              nome: "N/A",
              tempo_medio: 0,
              compraAtual: 0,
              status: "ativo",
            },
          ];
        }
      } catch (error) {
        console.error("Error fetching servico tipologia:", error);
      }
    },
    async selectTipologia(data) {
      this.tipologiaFormData = {};
      let imgUrl = await this.get_imagem(data.id, "tipologia");
      if (!imgUrl) {
        imgUrl = require("@/assets/hard_hat.svg");
      }
      //this.set_data = data;
      this.tipologiaFormData = data;
      this.tipologiaFormData.foto = imgUrl;
      this.set_data.familiaSelected = data.familia;
      this.set_data.produtoSelected = data.produto;
      this.set_data.tipoSelected = data.tipo;
      this.tipologiaFormTitle = "Editar Tipologia";
      this.showTipologiaForm = true;
      this.create_btn = false;
      this.showGenericTable = false;
      this.showRight = true;
      this.showServicoTable = false;
      this.showServicoData = false;
      this.getServicoTipologia();
    },
    async updateTiplogia(data) {
      const postData = {
        id: data.id,
        nome: data.nome,
        descricao: data.descricao,
        familia_id: data.familiaSelected.id,
        produto_id: data.produtoSelected.id,
        tpTipologia_id: data.tipoSelected.id,
      };
      try {
        const res = await axios.put(
          `${this.baseURl}/api/v1/tipologia/editar/${data.id}/`,
          postData,
        );
        this.upload_img(data, "tipologia");
        this.getTipologias();
        this.closeForm();
        this.$refs.dataTableRef.refresh();
        toast.success("Tipologia atualizada com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      } catch (error) {
        toast.error("Erro ao atualizar Tipologia", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        console.error("Error updating tipologia:", error);
      }
    },

    async getSeparadores() {
      try {
        const res = await axios.get(
          `${this.baseURl}/api/v1/tpseparador/?produto=${this.produtoFormData.id}`,
        );
        this.separadores = res.data.data;
        this.generic_table_data = this.separadores;
        this.generic_table_title = "Separadores";
        this.showGenericTable = true;
      } catch (error) {
        console.error("Error fetching separadores:", error);
        this.separadores = [];
      }
    },

    async getCampoSeparadores(separadorId) {
      try {
        const res = await axios.get(
          `${this.baseURl}/api/v1/campo_separador/tpSeparador/${separadorId}/`,
        );
        this.CamposSeparadores = res.data.data;
        this.showCamposSeparadoresTable = true;
        this.initialData = { tpSeparador_id: separadorId };
        this.showCamposSeparadoresForm = true;
        this.mode = "create";
      } catch (error) {
        console.error("Error fetching separadores:", error);
        this.separadores = [];
      }
    },

    SelectCampoSeparador(campo) {
      this.initialData = campo;
      this.showCamposSeparadoresForm = true;
      this.mode = "edit";
    },
  },

  watch: {
    "$route.query.view": {
      handler() {
        this.handleViewQuery();
      },
    },
    Spares: {
      handler: function (newVal, oldVal) {
        if (this.generic_table_title === "Spares") {
          this.generic_table_data = newVal;
        }
      },
      deep: true,
    },
    sparesByProduto: {
      handler: function (newVal, oldVal) {
        this.generic_table_data = newVal;
      },
      deep: true,
    },
    propriedadesFamilia: {
      handler: function (newVal) {
        this.generic_table_data = newVal;
      },
      deep: true,
    },
    produtoPros: {
      handler: function (newVal, oldVal) {
        this.generic_table_data = newVal;
      },
      deep: true,
    },

    tabela: {
      handler: function () {},
    },
    familia: {
      handler: function () {
        this.getFamilias();
      },
    },
    async selectedFiltro(newFiltro) {
      if (newFiltro) {
        this.filtroData = { ...newFiltro };
        delete this.filtroData.id;
        delete this.filtroData.status;
        this.show_table = true;
        this.table_title =
          this.filtroData.nome.charAt(0).toUpperCase() +
          this.filtroData.nome.slice(1).toLowerCase();
        const response = await axios.post(
          `${this.baseURl}/api/v1/filtro/testar/`,
          this.filtroData,
        );
        this.checkTable(this.tabela, response);
      } else {
        this.dataName(this.tabela);
      }
    },
  },
};
</script>

<style>
.scroll-style {
  overflow-y: auto;
  max-height: 80vh;
  scrollbar-color: gray transparent;
  scrollbar-width: thin;
}

.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}

.btn:hover {
  background-color: var(--icon) !important;
}
</style>
